import React, { useState } from 'react';
import { InputAdornment, IconButton } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import TextField from '~/components/CustomUI/TextField';

export default function Password({ ...rest }) {
  const [showPassword, setShowPassword] = useState(false);

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <TextField
      variant="filled"
      fullWidth
      name="password"
      label="Senha"
      type={showPassword ? 'text' : 'password'}
      id="password"
      autoComplete="current-password"
      color="primary"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={handleShowPassword}>
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...rest}
    />
  );
}
